<script>
/* eslint-disable no-console */
import NewForm from './New'
export default {
  mixins: [NewForm],
  data() {
    return {
      valid: null,
      id: null,
      root: {},
    }
  },
  methods: {
    load() {
      this.$http
        .get(`/long-distance-routes/${this.$route.query.id}`)
        .then((res) => {
          this.root = res.data
        })
    },
    save() {
      this.$http
        .put(`/long-distance-routes/${this.$route.query.id}`, this.root)
        .then(() => {
          this.returnToList()
          this.$message('', 'Success')
        })
        .catch(() => {
          this.$message('', 'Error')
        })
    },
    returnToList() {
      this.$router.push({
        name: 'M0300',
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
